import React, { Suspense, useMemo } from "react";
import { Switch, Route, topbar } from "react-router-loading";
import { Redirect } from "react-router-dom";
import { ThemeProvider, Global } from "@emotion/react";

import * as am4core from "@amcharts/amcharts4/core";
import am4themesAnimated from "@amcharts/amcharts4/themes/animated";

import { defaultTheme, reset, typography, library } from "@/styles";

import Error from "@/components/Error";
import NotFound from "@/components/Error/NotFound";
import { AuthRoute, GuestRoute } from "@/components/Route";
import moment from "moment";

am4core.useTheme(am4themesAnimated);
am4core.options.autoDispose = true;

topbar.config({
  barColors: {
    0: "rgba(95, 183, 227, 0.3)",
    0.3: "rgba(95, 183, 227, 0.5)",
    1.0: "rgba(95, 183, 227, 1)",
  },
});

const Ambari = React.lazy(() => import("@/pages/Ambari"));
const Nifi = React.lazy(() => import("@/pages/Nifi"));
const Control = React.lazy(() => import("@/pages/Control"));
const Butterfly = React.lazy(() => import("@/pages/Butterfly"));
const Pablo = React.lazy(() => import("@/pages/Pablo"));
const Weflo = React.lazy(() => import("@/pages/Weflo"));
const Auth = React.lazy(() => import("@/pages/Auth"));

function App() {
  // const fetched = useFetchToken();

  return (
    <ThemeProvider theme={defaultTheme}>
      <Global styles={[reset, typography, library]} />
      <Error>
        <Suspense>
          <Switch maxLoadingTime={300}>
            <Route exact path="/">
              <Redirect to="/auth" />
            </Route>
            <Route exact path="/ambari" component={Ambari} loading />
            <Route exact path="/nifi" component={Nifi} loading />
            <Route exact path="/butterfly" component={Butterfly} loading />
            <Route exact path="/pablo" component={Pablo} loading />
            <Route exact path="/weflo" component={Weflo} loading />
            <Route exact path="/auth" component={Auth} loading />
            <Route exact path="*" component={NotFound} />
          </Switch>
        </Suspense>
      </Error>
    </ThemeProvider>
  );
}

export default App;
